import React, { useEffect, useState } from 'react';
import './survey.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { toast } from 'react-toastify';
import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import surveyService from '../../features/survey/surveyService';
import authService from '../../features/auth/authService';
import Spinner from '../Layout/Spinner';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import pdfService from '../../features/pdf/pdfService';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import SubjectOutlinedIcon from '@mui/icons-material/SubjectOutlined';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as us from 'underscore';
import moment from 'moment';
import { TextareaAutosize } from '@material-ui/core';
import { styled } from '@mui/system';


const ITEM_HEIGHT = 34;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
      padding: 0,
    },
  },
};

const variants = [
  { id: 1, name: 'E02' },
  { id: 2, name: 'E03' },
  { id: 3, name: 'E01' },
  { id: 4, name: 'E04' },
  { id: 5, name: 'E05' },
  { id: 6, name: 'E06' },
  { id: 7, name: 'E07' },
  { id: 8, name: 'E08' },
  { id: 9, name: 'E09' },
  { id: 10, name: 'E10' },
];

function Survey(props) {
  const [surveydata, setSurveyData] = useState([]);
  const [surveyTakenDate, setSurveyTakenDate] = useState([]);
  let [isLoading, setIsLoading] = useState(false);
  let [isSave, setIsSave] = useState(false);
  let [isGoBack, setIsGoBack] = useState(false);
  const [allSelect, setAllSelect] = useState([]);
  const [selectedBlockOptions, setSelectedBlockOptions] = useState([]);
  const [closeColumnChecked, setCloseColumnChecked] = useState(false);
  const [isSurveySubmitted, setSurveySubmitted] = useState(false);
  const [isSurveySubmittedNow, setSurveySubmittedNow] = useState(false);
  const [showDownloadPdf, setShowDownloadPdf] = useState(false);
  const [distName, setDistName] = useState('');
  const [pdfData, setPdfData] = useState([]);
  const [isShowSaveButton, showSaveButton] = useState(false);

  const [openAdd, setOpenAdd] = React.useState(false);

  const [values, setValues] = React.useState({ name: "" });
  const [infovalues, setInfoValues] = React.useState({ info: "" });

  const wordCountHandle = name => event => {
    setValues({ ...values, [name]: event.target.value });
  };

  const wordCountHandleInfo = info => event => {
    setInfoValues({ ...infovalues, [info]: event.target.value });
  };

  const currentDate = dayjs(); // Get the current date

  const navigate = useNavigate()

  useEffect(() => {
    setIsLoading(true);
    document.title = props.title
    const fetchData = async () => {
      try {
       
        console.log(authService.getDist())
        const response = await axios.post(config.basePath + 'survey/getsurveypagedata', {
          districtId: localStorage.getItem('districtId'),
          academicyear:localStorage.getItem('academicyear')
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

         // Check if response data is valid
        if (!response.success) {
          // throw new Error('Invalid response data');
          console.log("There os a erroe")
          setIsLoading(false);
        }

        const jsonData = response.data;
     
        if(jsonData.surveyPageData.length == 0){ 
          toast.warning('No survey is selected. Please select at least one survey on the Home tab.');
        }
        console.log(jsonData);
        const survPdfData = JSON.parse(JSON.stringify(jsonData));

        for (let i = 0; i < survPdfData.surveyPageData.length; i++) {
          let filteredArr = survPdfData.surveyPageData[i].schoolSurveyData.filter(f => {
            let arr = f.moduleData.map((g) => {
              if (g.value == 1) return g
            })
            arr = arr.filter(a => {
              return a
            })
            f['checkArr'] = arr
            return f['checkArr'].length > 0
          })
          survPdfData.surveyPageData[i].schoolSurveyData = filteredArr
        }

        console.log('jsonData', jsonData.surveyPageData);
        console.log('survPdfData', survPdfData.surveyPageData);

        setDistName(response.data.distName);
        
        if(jsonData.distSubmitType == 'sr' && localStorage.getItem('role') == 'dc'){
          toast.info('Survey Registration has been submitted. To update your survey module selections, please contact your CalSCHLS Technical Advisor.');
        }

        if (jsonData.distSubmitType == 'sr'){
          setSurveySubmitted(true);
          setIsSave(true);
          setShowDownloadPdf(true)
        }
        console.log(isSurveySubmitted);
        // setIsLoading(false);
        setSurveyData(jsonData);
        setPdfData(survPdfData)
        setSurveyTakenDate(dayjs(jsonData.surveyTakenDate));

      } catch (error) {
        // $('spinnerId').css('display', 'none');
        // document.getElementById('spinnerId').style.display = 'none';
        setIsLoading(false);
        console.log("IsLoding variable: " +isLoading)
        // console.error('Error fetching data:', error);
        toast.error('Data Not Found');
      }finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [props.title]);

  // useEffect(() => {
  //   setIsLoading(true);
  //   console.log('isLoading changed:', isLoading);
  // }, [isLoading]);
 
  
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  let selectedModuleIds = [];

  const blockOptions = [
    { id: 1, name: 'E01' },
    { id: 2, name: 'E02' },
    { id: 3, name: 'E03' },
    { id: 4, name: 'E04' },
    { id: 5, name: 'E05' },
    { id: 6, name: 'E06' },
    { id: 7, name: 'E07' },
    { id: 8, name: 'E08' },
    { id: 9, name: 'E09' },
    { id: 10, name: 'E10' },
    { id: 11, name: 'E11' },
    { id: 12, name: 'E12' },
    { id: 13, name: 'E13' },
    { id: 14, name: 'E14' },
    { id: 15, name: 'E15' },
    { id: 16, name: 'E16' },
    { id: 17, name: 'E17' },
    { id: 18, name: 'E18' },
    { id: 19, name: 'E19' },
    { id: 20, name: 'E20' },
    { id: 21, name: 'E21' },
    { id: 22, name: 'E22' },
    { id: 23, name: 'E23' },
    { id: 24, name: 'E24' },
    { id: 25, name: 'E25' },
    { id: 26, name: 'E26' },
    { id: 27, name: 'E27' },
    { id: 28, name: 'E28' },
    { id: 29, name: 'E29' },
    { id: 30, name: 'E30' },
    { id: 31, name: 'E31' },
    { id: 32, name: 'E32' },
    { id: 33, name: 'E33' },
    { id: 34, name: 'E34' },
    { id: 35, name: 'E35' },
    { id: 36, name: 'E36' },
    { id: 37, name: 'E37' },
    { id: 38, name: 'E38' },
    { id: 39, name: 'E39' },
    { id: 40, name: 'E40' }
  ];


  const msblockOptions = [
    { id: 1, name: 'M01' },
    { id: 2, name: 'M02' },
    { id: 3, name: 'M03' },
    { id: 4, name: 'M04' },
    { id: 5, name: 'M05' },
    { id: 6, name: 'M06' },
    { id: 7, name: 'M07' },
    { id: 8, name: 'M08' },
    { id: 9, name: 'M09' },
    { id: 10, name: 'M10' },
    { id: 11, name: 'M11' },
    { id: 12, name: 'M12' },
    { id: 13, name: 'M13' },
    { id: 14, name: 'M14' },
    { id: 15, name: 'M15' },
    { id: 16, name: 'M16' },
    { id: 17, name: 'M17' },
    { id: 18, name: 'M18' },
    { id: 19, name: 'M19' },
    { id: 20, name: 'M20' },
    { id: 21, name: 'M21' },
    { id: 22, name: 'M22' },
    { id: 23, name: 'M23' },
    { id: 24, name: 'M24' },
    { id: 25, name: 'M25' },
    { id: 26, name: 'M26' },
    { id: 27, name: 'M27' },
    { id: 28, name: 'M28' },
    { id: 29, name: 'M29' },
    { id: 30, name: 'M30' },
    { id: 31, name: 'M31' },
    { id: 32, name: 'M32' },
    { id: 33, name: 'M33' },
    { id: 34, name: 'M34' },
    { id: 35, name: 'M35' },
    { id: 36, name: 'M36' },
    { id: 37, name: 'M37' },
    { id: 38, name: 'M38' },
    { id: 39, name: 'M39' },
    { id: 40, name: 'M40' },
    { id: 41, name: 'M41' },
    { id: 42, name: 'M42' },
    { id: 43, name: 'M43' },
    { id: 44, name: 'M44' },
    { id: 45, name: 'M45' },
    { id: 46, name: 'M46' },
    { id: 47, name: 'M47' },
    { id: 48, name: 'M48' },
    { id: 49, name: 'M49' },
    { id: 50, name: 'M50' },
    { id: 51, name: 'M51' },
    { id: 52, name: 'M52' },
    { id: 53, name: 'M53' },
    { id: 54, name: 'M54' },
    { id: 55, name: 'M55' },
    { id: 56, name: 'M56' },
    { id: 57, name: 'M57' },
    { id: 58, name: 'M58' },
    { id: 59, name: 'M59' },
    { id: 60, name: 'M60' },
    { id: 61, name: 'M61' },
    { id: 62, name: 'M62' },
    { id: 63, name: 'M63' },
    { id: 64, name: 'M64' },
    { id: 65, name: 'M65' },
    { id: 66, name: 'M66' },
    { id: 67, name: 'M67' },
    { id: 68, name: 'M68' },
    { id: 69, name: 'M69' },
    { id: 70, name: 'M70' },
    { id: 71, name: 'M71' },
    { id: 72, name: 'M72' },
    { id: 73, name: 'M73' },
    { id: 74, name: 'M74' },
    { id: 75, name: 'M75' },
    { id: 76, name: 'M76' },
    { id: 77, name: 'M77' },
    { id: 78, name: 'M78' },
    { id: 79, name: 'M79' },
    { id: 80, name: 'M80' },
    { id: 81, name: 'M81' },
    { id: 82, name: 'M82' },
    { id: 83, name: 'M83' },
    { id: 84, name: 'M84' },
    { id: 85, name: 'M85' },
    { id: 86, name: 'M86' },
    { id: 87, name: 'M87' },
    { id: 88, name: 'M88' },
    { id: 89, name: 'M89' },
    { id: 90, name: 'M90' }
  ];


  const ssblockOptions = [
    { id: 1, name: 'S01' },
    { id: 2, name: 'S02' },
    { id: 3, name: 'S03' },
    { id: 4, name: 'S04' },
    { id: 5, name: 'S05' },
    { id: 6, name: 'S06' },
    { id: 7, name: 'S07' },
    { id: 8, name: 'S08' },
    { id: 9, name: 'S09' },
    { id: 10, name: 'S10' },
    { id: 11, name: 'S11' },
    { id: 12, name: 'S12' },
    { id: 13, name: 'S13' },
    { id: 14, name: 'S14' },
    { id: 15, name: 'S15' },
    { id: 16, name: 'S16' },
    { id: 17, name: 'S17' },
    { id: 18, name: 'S18' },
    { id: 19, name: 'S19' },
    { id: 20, name: 'S20' },
    { id: 21, name: 'S21' },
    { id: 22, name: 'S22' },
    { id: 23, name: 'S23' },
    { id: 24, name: 'S24' },
    { id: 25, name: 'S25' },
    { id: 26, name: 'S26' },
    { id: 27, name: 'S27' },
    { id: 28, name: 'S28' },
    { id: 29, name: 'S29' },
    { id: 30, name: 'S30' },
    { id: 31, name: 'S31' },
    { id: 32, name: 'S32' },
    { id: 33, name: 'S33' },
    { id: 34, name: 'S34' },
    { id: 35, name: 'S35' },
    { id: 36, name: 'S36' },
    { id: 37, name: 'S37' },
    { id: 38, name: 'S38' },
    { id: 39, name: 'S39' },
    { id: 40, name: 'S40' },
    { id: 41, name: 'S41' },
    { id: 42, name: 'S42' },
    { id: 43, name: 'S43' },
    { id: 44, name: 'S44' },
    { id: 45, name: 'S45' },
    { id: 46, name: 'S46' },
    { id: 47, name: 'S47' },
    { id: 48, name: 'S48' },
    { id: 49, name: 'S49' },
    { id: 50, name: 'S50' },
    { id: 51, name: 'S51' },
    { id: 52, name: 'S52' },
    { id: 53, name: 'S53' },
    { id: 54, name: 'S54' },
    { id: 55, name: 'S55' },
    { id: 56, name: 'S56' },
    { id: 57, name: 'S57' },
    { id: 58, name: 'S58' },
    { id: 59, name: 'S59' },
    { id: 60, name: 'S60' },
    { id: 61, name: 'S61' },
    { id: 62, name: 'S62' },
    { id: 63, name: 'S63' },
    { id: 64, name: 'S64' },
    { id: 65, name: 'S65' },
    { id: 66, name: 'S66' },
    { id: 67, name: 'S67' },
    { id: 68, name: 'S68' },
    { id: 69, name: 'S69' },
    { id: 70, name: 'S70' },
    { id: 71, name: 'S71' },
    { id: 72, name: 'S72' },
    { id: 73, name: 'S73' },
    { id: 74, name: 'S74' },
    { id: 75, name: 'S75' },
    { id: 76, name: 'S76' },
    { id: 77, name: 'S77' },
    { id: 78, name: 'S78' },
    { id: 79, name: 'S79' },
    { id: 80, name: 'S80' },
    { id: 81, name: 'S81' },
    { id: 82, name: 'S82' },
    { id: 83, name: 'S83' },
    { id: 84, name: 'S84' },
    { id: 85, name: 'S85' },
    { id: 86, name: 'S86' },
    { id: 87, name: 'S87' },
    { id: 88, name: 'S88' },
    { id: 89, name: 'S89' },
    { id: 90, name: 'S90' }
  ];

  const psblockOptions = Array.from({ length: 30 }, (_, index) => {
    const id = index + 1;
    const name = 'P' + (id < 10 ? '0' + id : id);
    return { id, name };
  });

  const stblockOptions = Array.from({ length: 30 }, (_, index) => {
    const id = index + 1;
    const name = 'ST' + (id < 10 ? '0' + id : id);
    return { id, name };
  });
  const handleSelectAllChange = (event, moduleId, moduleIndex, shortCode) => {
    const checked = event.target.checked;
    if (checked) {
      setAllSelect(prevState => [...prevState, moduleIndex]);
    } else {
      setAllSelect(prevState => prevState.filter(item => item !== moduleIndex));
    }

    setCheckboxStates((prevStates) => ({
      ...prevStates,
      [moduleId]: checked
        ? surveydata.surveyPageData.flatMap((survey) => survey.schoolSurveyData.map((_, i) => i + 1))
        : [],
    }));

    // Also update the `value` fields of the corresponding modules
    setSurveyData((prevData) => {
      const updatedData = JSON.parse(JSON.stringify(prevData)); // Deep clone
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school) => {
          const module = school.moduleData.find((mod) => mod.moduleId === moduleId);

          if (module) {
            // Update the `value` fields based on the checkbox state
            module.value = checked ? 1 : 0;
          }
        });
      });

      return updatedData;
    });
  };


  const [selectedValue, setSelectedValue] = useState(false);

  const handleChange = (event, schoolId, shortCode) => {
    const checked = event.target.checked;
    showSaveButton(true);
    // Update the `closeData` field of the corresponding school
    setSurveyData((prevData) => {
      const updatedData = JSON.parse(JSON.stringify(prevData)); // Deep clone

      if (shortCode == 'es') {

        let esSurvey = updatedData.surveyPageData.find((survey) => survey.shortCode === 'es');
        if (esSurvey) {
          esSurvey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            if (school.schoolId === schoolId) {
              // Update the `closeData` field based on the checkbox state
              school.closeData = checked ? 1 : 0;
            }
          });
        }
      }

      if (shortCode == 'ms') {
        let msSurvey = updatedData.surveyPageData.find((survey) => survey.shortCode === 'ms');
        if (msSurvey) {
          msSurvey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            if (school.schoolId === schoolId) {
              // Update the `closeData` field based on the checkbox state
              school.closeData = checked ? 1 : 0;
            }
          });
        }
      }

      if (shortCode == 'hs') {
        let hsSurvey = updatedData.surveyPageData.find((survey) => survey.shortCode === 'hs');
        if (hsSurvey) {
          hsSurvey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            if (school.schoolId === schoolId) {
              // Update the `closeData` field based on the checkbox state
              school.closeData = checked ? 1 : 0;
            }
          });
        }

      } else {
        updatedData.surveyPageData.forEach((survey) => {
          survey.schoolSurveyData.forEach((school) => {
            if (school.schoolId === schoolId && survey.shortCode == shortCode) {
              // Update the `closeData` field based on the checkbox state
              school.closeData = checked ? 1 : 0;
            }
          });
        });
      }

      return updatedData;
    });
  };

  const handleCloseAllChange = (event, surveyId, shortCode) => {
    const checked = event.target.checked;
    showSaveButton(true);

    setSurveyData((prevData) => {
      const updatedData = JSON.parse(JSON.stringify(prevData)); // Deep clone
      if (shortCode == 'es') {

        let esSurvey = updatedData.surveyPageData.find((survey) => survey.shortCode === 'es');
        if (esSurvey) {
          esSurvey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            school.closeData = checked ? 1 : 0;
          });
        }
      }
      if (shortCode == 'ms') {
        let msSurvey = updatedData.surveyPageData.find((survey) => survey.shortCode === 'ms');
        if (msSurvey) {
          msSurvey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            school.closeData = checked ? 1 : 0;
          });
        }
      }

      if (shortCode == 'hs') {
        let hsSurvey = updatedData.surveyPageData.find((survey) => survey.shortCode === 'hs');
        if (hsSurvey) {
          hsSurvey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            school.closeData = checked ? 1 : 0;
          });
        }
      } else {
        let survey = updatedData.surveyPageData.find((survey) => survey._id === surveyId);
        if (survey) {
          survey.schoolSurveyData.forEach((school) => {
            // Update the `closeData` field of schools in the same survey component
            school.closeData = checked ? 1 : 0;
          });
        }
      }
      return updatedData;
    });
  };



  const handleSelectMultiBlock = (event, schoolIndex, rowIndex, surveyId, schoolId) => {
    const { value, checked } = event.target;
    showSaveButton(true);
    console.log(value);
    setSelectedBlockOptions((prevStates) => ({
      ...prevStates,
      [schoolIndex]: value
    }));

    console.log(selectedOptions);
    // Update the blockData array of each school in the surveydata state
    setSurveyData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school, index) => {
          if (survey._id == surveyId && school.schoolId == schoolId) {
            school.blockData = value;
          }
        });
      });
      return updatedData;
    });
  };
  const [allBlockData, setAllBlockData] = useState({});

  const handleSelectAllMultiBlock = (event, surveyId) => {
    const { value, checked } = event.target;
    showSaveButton(true);
    setAllBlockData((prevStates) => ({
      ...prevStates,
      [surveyId]: value
    }));

    // Update the blockData array of each school in the surveydata state
    setSurveyData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school, index) => {
          if (survey._id == surveyId) {
            school.blockData = value;
          }
        });
      });
      return updatedData;
    });
  };

  const handleSelectAllTupeOption = (event, surveyId) => {
    const { value, checked } = event.target;

    showSaveButton(true);
    setSelectedAllTupeOptions((prevStates) => ({
      ...prevStates,
      [surveyId]: value
    }));
    console.log(selectedAllTupeOptions);

    // Update the blockData array of each school in the surveydata state
    setSurveyData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school, index) => {
          let v = value == 2 ? school.tupe : value;
          if (survey._id == surveyId) {
            school.tupe = v;
          }
        });
      });
      return updatedData;
    });
  };

  const handleSelectTupeOption = (event, surveyId, schoolId) => {
    const { value, checked } = event.target;
    showSaveButton(true);
    console.log(value);
    setSelectedTupeOptions((prevStates) => ({
      ...prevStates,
      [schoolId]: value
    }));

    // Update the blockData array of each school in the surveydata state
    setSurveyData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school, index) => {
          if (survey._id == surveyId && school.schoolId == schoolId) {
            school.tupe = value;
          }
        });
      });
      return updatedData;
    });
  };

  const handleDateChange = (date) => {
    const currentDate = dayjs(); // Get the current date
    if (date.isBefore(currentDate, 'day')) {
      toast.warning('Please provide anticipated earliest date of survey administration. Click “Go Back” to enter a date.');
      // Check if the selected date is before the current date
      return; // Exit the function without updating the state
    } else {
      setSurveyTakenDate(date);
    }
  };


  const updateSurveyData = () => {
    setSurveyData((prevData) => {
      let updatedData = JSON.parse(JSON.stringify(prevData)); // Deep clone
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school, i) => {
          school.moduleData.forEach((module) => {
            module.value = checkboxStates[module.moduleId]?.includes(i + 1) ? 1 : 0;
          });
        });
      });
      return updatedData;
    });
  };


  const handleSaveSurvey = async () => {
    try {
      setIsLoading(true);
      const date1 = surveyTakenDate.$d;
      const formattedDate = `${date1.getFullYear()}-${String(date1.getMonth() + 1).padStart(2, '0')}-${String(date1.getDate()).padStart(2, '0')}T00:00:00.000+00:00`;
      surveyService.saveSurveyPageDate({
        schoolSurveyData: surveydata.surveyPageData,
        // surveyTakenDate: surveyTakenDate, districtId: authService.getDist(), userId: authService.getUserId()
        surveyTakenDate: formattedDate, districtId: authService.getDist(), userId: authService.getUserId()
      }).then((response) => {
        toast.success(response.data.message);
        setIsSave(true);
        setIsLoading(false);
        setShowDownloadPdf(true)
        fetchDataforpdf();
      }).catch(err => {
        toast.error(err.message ? err.message : "Unable to fetch survey data.");
        setIsLoading(false);
      })
    } catch (error) {
      console.error('Error saving data:', error);
    }

  };

  const handleBTCSaveSurvey = async () => {
    try {
      setIsLoading(true);
      surveyService.saveSurveyPageDate({
        schoolSurveyData: surveydata.surveyPageData,
        surveyTakenDate: surveyTakenDate, districtId: authService.getDist(), userId: authService.getUserId()
      }).then((response) => {
        toast.success("Survey data updated.");
        setIsSave(true);
        setIsLoading(false);
        showSaveButton(false);
        setShowDownloadPdf(true)
      }).catch(err => {
        toast.error(err.message ? err.message : "Unable to fetch survey data.");
        setIsLoading(false);
        showSaveButton(false);
      })
    } catch (error) {
      console.error('Error saving data:', error);
    }

  };

  const [checkboxStates, setCheckboxStates] = useState({});

  const handleCheckboxChange = (event, moduleId, rowIndex, surveyId, schoolId) => {
    const checked = event.target.checked;

    setCheckboxStates((prevStates) => ({
      ...prevStates,
      [moduleId]: checked
        ? [...(prevStates[moduleId] || []), rowIndex]
        : (prevStates[moduleId] || []).filter((i) => i !== rowIndex),
    }));

    // Also update the `value` field of the corresponding module
    setSurveyData((prevData) => {
      const updatedData = JSON.parse(JSON.stringify(prevData)); // Deep clone
      updatedData.surveyPageData.forEach((survey) => {
        survey.schoolSurveyData.forEach((school, schoolIndex) => {
          const module = school.moduleData.find((mod) => mod.moduleId === moduleId);
          if (survey._id == surveyId && school.schoolId == schoolId) {
            if (module) {
              // Update the `value` field based on the checkbox state
              module.value = checked && (schoolIndex + 1 === rowIndex) ? 1 : 0;
            }
          }
        });
      });

      return updatedData;
    });
  };



  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(config.basePath + 'survey/submitsurveyregistration', {
        districtId: localStorage.getItem('districtId'),
        lastname: localStorage.getItem('lastName'),
        userId: authService.getUserId()
      })
        .then((response) => {
          toast.success(response.data.message ? response.data.message : "Error in submiting the data");
          setSurveySubmitted(true);
          setSurveySubmittedNow(true)
          setIsLoading(false);
        })
        .catch(err => {
          toast.error(err.response.data.message ? err.response.data.message : "Error");
          setIsLoading(false);
        });
    } catch (error) {
      // Request failed due to an error
      console.error('Error saving data:', error);
      toast.warning('Error occurred while saving data');
    }
  };


  const handleGoBack = () => {
    setIsSave(false)
  }

  const goEnrollment = () => {
    navigate('/enrollment');
  };

  const handleResetSelection = (event, shortCode) => {
    event.stopPropagation();
    setAllSelect(prevState => prevState.filter(item => 1 == 2));

    const checked = event.target.checked;
    console.log(checkboxStates)


    // Also update the `value` field of the corresponding module
    setSurveyData((prevData) => {
      const updatedData = JSON.parse(JSON.stringify(prevData)); // Deep clone
      updatedData.surveyPageData.forEach((survey) => {
        if (survey.shortCode == shortCode) {
          survey.schoolSurveyData.forEach((school, schoolIndex) => {
            school.moduleData.find((mod) => {
              console.log(mod);
              if (mod.shortCode != 'Core') {
                mod.value = false;
                setCheckboxStates((prevStates) => ({
                  ...prevStates,
                  [mod.moduleId]: false
                }));
              }
            });
          });
        }
      });

      return updatedData;
    });

  };

  const handleSurveyGoBack = () => {
    setSurveySubmittedNow(false);
  };



  const handleSave = async () => {
    alert("Data Saved!")
  };

  const addDashboardClose = () => {
    setOpenAdd(false);
    setValues({ name: "" });
  };


  const [selectedOptions, setSelectedOptions] = useState([[]]);
  const [selectedTupeOptions, setSelectedTupeOptions] = useState([]);
  const [selectedAllTupeOptions, setSelectedAllTupeOptions] = useState([]);

  let urlDistName = (distName.replace("%20", " ")).replace(/ /g, "")
  // console.log('urlDistName', urlDistName);

  const addDashboardDialog = () => {
    setOpenAdd(true);
  };

  // const downloadSurveyPdf = () => {
  //   console.log('districttoken', localStorage.getItem('districtId'));
  //   setIsLoading(true);
  //   pdfService.downloadpdf('surveypdf', {
  //     role: authService.getRole(),
  //     districtId: localStorage.getItem('districtId'),
  //     token: encodeURIComponent(authService.getToken())
  //     // token: encodeURIComponent('64b52eda4c32df5b481f9f46')
  //   }, 'SurveyModule_' + urlDistName).then((response) => {
  //     setIsLoading(false);
  //     console.log(response)
  //   }).catch((err) => {
  //     setIsLoading(false);
  //     console.log(err)
  //   })
  // }

  // { header: 'TRM', dataKey: 'traum' }, { header: 'AOD', dataKey: 'aod' }
  let headerKeys = [{ header: 'Core', dataKey: 'cm' }, { header: 'BHM', dataKey: 'bhm' },
  { header: 'SCM', dataKey: 'schcmt' }, { header: 'SEHM', dataKey: 'sehm' }, { header: 'Well', dataKey: 'well' },
  { header: 'TIP', dataKey: 'tip' }, { header: 'CHM', dataKey: 'bhc' }, { header: 'CSCH', dataKey: 'csch' }, { header: 'CTAG', dataKey: 'cag' },
  { header: 'DFC', dataKey: 'dfc' }, { header: 'LGBTQ', dataKey: 'lbh' }, { header: 'MHS', dataKey: 'cw' },
  { header: 'TUPE', dataKey: 'tupe' }, { header: 'DASM', dataKey: 'dasm' }, { header: 'GRAM', dataKey: 'gra' },
  { header: 'Mil', dataKey: 'mcs' }, { header: 'RYDM', dataKey: 'ryd' }, { header: 'SafeV', dataKey: 'sv' },
  { header: 'SexB', dataKey: 'sb' }, { header: 'Tob', dataKey: 'tbc' }, { header: 'HLTH', dataKey: 'sh' },
  { header: 'SpED', dataKey: 'ses' }, { header: 'Cust', dataKey: 'cstm' }];
  // , { header: 'close', dataKey: 'close' }

  const downloadSurveyPdf = () => {
    let chkImage = "data:image/png;base64,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";
    let hdrImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAAAeCAYAAAA7HGznAAAJwklEQVR4nO1caZAdVRX+ut97k8xk3iQTyIQsJpDJJIFANCElDgqVRFzAtVgluAClgqDGsiwsFX5gKUsRlsI1alEBVETLAtQqwqaACSBEMWSRRbOHMMkwS4aZvJn3+rV1Jt+ljtd+Sy8TXki+qq7pfn379L3nnj7n3HPOHee3l01AjaMVwC0A6gHsBXApgMEiXBzrduDBwntwa+4itDjdcODX+lgOa6QPgcFPB/Bxdf0lEbZ6ZxBdfiMeHToFdSgcEbRDAKWErQHAqQBmA5jC6wzvFQDkAHQB2A7gRQDr+ftIYEDR7AZQFK020enB7/OL8ax3Io5zd8GHY9qcBODdAI4DMIZ9l5segH7S2wFgG4BXqC3fqLLfLoB2AO9SfKkvQf/fAJ7lbwbzAJwCDH8ZvQB+F5FfHwYwjXTWAnjeui99Oo9zJn1+nGNNAqdzHJMBNAIYTZp58nEfebsVwGYAe4xs2MJ2JoCLASwBcHSIjn0BwC8SGkxF1GMQ3f4YPJ5fgKzzpixeRQYvDElOJv0+AJeUaSMC/A3yZWoI2kL3bHV9OTWzgRP8WEX8kO6FYGVA3ycCuFNdfx3ArRHfJRgF4CYAZ6n3VoMCP+ZrAazQwvZZq4NhMCXGQEKj2dmHBwqLsdGbialuh2i1uwB8JiK5sQDGlbn/XgCrI9I+wbruUec7ItIUvKomvTvgftG63hfjXUcBeJTaPCxEvibREr6p2eYGCFqRpqCLqnAfJdWh6pQJGs/J2hJjMKHgDNsOBy95081jFwQI2ms8jIkc5KMZmtYm9ruOY/hRiT60AHgy4HcxE6/zEPpDNGmiAbKkL/x5JoCnQedhUYmOz8NR11Hx4wBB20remvFruWjk+LN0M1LGXTDC9hOL2N0AvhPz6xsR1Dl5dPrjsLc4Do3OgAjet6z3iJm6gwJQDRosv1Djcvo8BmsALAPw91rjywhB/LLzFenttIBPVPk684EPz0WaP5ysGjxAgjWJNAroQhN6/CxGYUhMyTtVP78C4Kch+11K0EAf0KADwPtqlS8jhE8qsqK9TqPAVQtff/Ty1S7g121wYy2PXkxoGh4yKKAIV6t3jxo5KYidPlHRuurgjrQm0KY6sS2koP0fRLPNVz92Ang65iiF5vsZfmgGMJP+UZr2G/QzxI/aQJN0v+U8V4s61S4f0zexMde6tv2vwwF6tVytW1ISacajDNYlwECx86uqbLuIf28GsBzA9SHfZTvHSQrbeHXuhYjFvZ2g+Rubty7NhUFXAowaFeEZmdjr6HOFgQ7d1CUsbFl1Ll/1/gRpHyrIqH42xO1z2mJqEsLWScEZoI3fxViQCQ+47HgrA7CXMRwBarcflCMuaSkPLjyk5Pw/6pbQ/R6AryUwBlgmxBvBDEktY4/qmyilDwF4KGp/05Ym6k1g4N0Mm1SCpHLuAfAIgAfZVrTT8QD+VepZSVVJLjSDvJyvZTrICOsyRvjvo5B3UiN1sl0YgRmtzntMYDJBxPGB+qtokwT+DOC7pOPQPZLsxV+4On+d/BUl1VfpfWnLN3kr/JJVzK/O4fXJ5YRtyM9ggtOFCW43tnhTC40YuMWHc41qcg4PDZOzexnAbubs1jFo/QI1lw2dVdjFBUiSaGGIaX+IgogiF1mzE+5LKayx5kbwZR4afdSCW1TOeQP/vmza1UrVxzo1oEnlGooJlYqPttQOrC7Mh+P41/pwljCtVAqNPCYH3N9OU24varQZHYmSkrEx0oMHE+cwiFsuV57lEZQ3/SuATwufXYuRURPDcaHze6lKtLr9JpyZWYPjU5vR5Y/1nAPB1ouZWgqrgabRjM+xftd8cXH4YhOAWQCuprYKi9NMxiVtabcgc5IEGjl5+0vk8rS9r9iHfr8erW4H2tPrsSI3C+NTvfDh3klNcQz9vmaawgk8n8uk8mzLdTCQlN1ida2FPmkTCsYZ10TUmgupGQ8WRBl8n8cMBnvHko9HkedzqP1arUUn+PuytLUoGJNQ52Vir+SL29gpn75TPwXOJLB7rZRTRbgoosPP4oOZp/FM4STsLE5Es9NnZs0k4UuhgVUq7Vy9voPtFpGBhh+6UqKF2i1O8tzGqwx+R8HDAD6QYF/CYDOPUshyzs+wslEXpC2m2hIZBfPKBIfLlfKEQp/fgDa3A2dk/obbc0uHy46q9AIG6Li+wgdWqntTlLBpbXsMCxKTXAXGcVlqucJa+PYPHiJ0n+fv49OWiYgrDPL1/0Fdd9EfetEqebHxMaa3qkYKRez2m7Ak/RyeTC3A1uJkNDmhZcGuaqkv0S41AhMcR9gOFR/yKSVso9KWyYkrbKdbGYl2vfQtg9FhhU3ibfXIYZc/cVjLpaJZuEyZe4NWu7oybY8gGJpnnmvZ31kxmTZTna+vUtBApzMU6p0c8sjgttxS7PAnRdFqlaBXyBkWBB5BOPxPpMO1AqizGAqICq3eO0PQCLVAOLDhpRcPFdqxwZuJSc7e4fhbBNgrQa0et1n3Dmrp+9sEmr++S7uq0zhfjDFO7YdUa3ZOCKjVLwvRarKNb3V+PrLxNJodqNyrzp+3csXX4AjCQpev9btcje5WP8pOnE9FZKtebMyr8pmyifcgSJhjVeFUbPJm4GinR2/jC4NWS4D2MBxhIFruj+palvLfjPKiGsDOt6ALH7F2fb1gVljXc2MDuCK7hwL3BH2XbgZkjVp0mMA3gdNN3IHznCKe5UaHlcw/9qgV6VQGV8/j9rg3GPitCFkIDPoZbCzMGI63cQ/lR8nQHgaF9/O8YJnGRmozCfpeYWnfmwLiaD8D8Dl1fQOAc1ns+Ro/1D71nKm5b6aPJ+//ecLxuSiQMRwbYkXtc96Ej19lzeNOzpPHcZtzLRPN5K/sOb7Qorlcb3hZbNXcf4JHNfgNhW09J8LUrp/LwwRxjbBpZ1sm9DEA91bLRCkvEkFLOx6YF70yzkwwIb884PenGDXXVSwLQ+xNlclYEbNvSWApjzC4n8J2RQKJ/19K7FV71eeTMVH2GGo7diE1mYarts9pQVvLJLgOM9ipJB37ag6IMcVNsf2TIZpSuJrCtrs8mUDYfdX/WGV6hWfLQS/iWgLaZRLIc5vn4/L312arpa1WZevat2lvF1F9Nqt/MWAwRE01wFXbr9S9HFeXF7FiYJrKTPisgXqJNWfGJ/JYOwVOvsYeaj55f68PpyAbXsY4OeOr3UthnUJTkWJ/s2r3mEaeCwEpvPwTv+BKuI6a72zypY18sdN7JiXXy4/2Eeu+aEpTGaELE8NC+mx8YqmqsCHvl3dHDf7KOIwCkI9NHH0Ja4lgC38l5Sf8DSqakBWbLKw20h07sHcDwH8BeAB2xzdQaRcAAAAASUVORK5CYII=";
    // let hdrImage = environment.hdrImage;
    let doc = new jsPDF('l');
    /* let doc = new jsPDF('l', 'pt', 'a4'); */
    doc.addImage(hdrImage, 'PNG', 14, 14, 30, 8, 'logo');
    doc.setFontSize(14);
    doc.setTextColor(143, 149, 151);
    doc.text(14, 28, 'CalSCHLS Coordinator Portal');

    doc.setFontSize(12);
    doc.setTextColor(248, 119, 28);
    doc.text(14, 35, distName);

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(14, 42, 'SURVEY MODULE SELECTION');
    doc.setTextColor(0, 60, 104);
    doc.autoTable({
      startY: 45,
      tableLineColor: [231, 76, 60],
      styles: {
        lineColor: 240,
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [0, 60, 104],
        textColor: 240,
        fontSize: 6,
        fontStyle: 'bold',
        halign: 'center'
      },
      bodyStyles: {
        textColor: [0, 60, 104],
        fontSize: 7
      },
      columnStyles: getColumnStyle(),
      body: createJSONforPDF(),
      columns: getColumns(),

      didParseCell: (data) => {
        if ((data.row.section === 'body') && (us.indexOf(['close', 'cm', 'cstm', 'bhm', 'csch', 'sehm', 'cw', 'tupe', 'dasm', 'gra', 'mcs', 'sh', 'mc', 'schcmt', 'tbc', 'dfc', 'well', 'tip', 'bhc', 'cag', 'lbh', 'ryd', 'sv', 'sb', 'ses'], data.column.dataKey) > -1)) {
          if ((data.cell.raw === true) || (data.cell.raw === false)) {
            data.cell.text = '';
          }
        }
      },
      didDrawCell: (data) => {
        if ((data.row.section === 'body') && (us.indexOf(['close', 'cm', 'bhm', 'csch', 'cstm', 'sehm', 'cw', 'tupe', 'dasm', 'gra', 'mcs', 'sh', 'mc', 'schcmt', 'tbc', 'dfc', 'well', 'tip', 'bhc', 'cag', 'lbh', 'ryd', 'sv', 'sb', 'ses'], data.column.dataKey) > -1)) {
          if (data.cell.raw === true) {
            doc.addImage(chkImage, 'PNG', data.cell.x + 2, data.cell.y + 2, 2.5, 2.5, 'chkImage');
          }
        }
      }
    });

    doc.save(pdfFileName());
  }


  const getColumnStyle = () => {
    let output = {};
    try {
      if ((authService.getRole() === 'admin')) {
        output['surveyNm'] = { cellWidth: 20 };
        output['sn'] = { cellWidth: 22.8 };
        output['sid'] = { cellWidth: 17 };
        headerKeys.map(element => {
          output[element.dataKey] = { cellWidth: 8 };
        });
        output['close'] = { cellWidth: 8 }
        output['block'] = { cellWidth: 15 };
        output['atupe'] = { cellWidth: 10 };
      } else {
        output['surveyNm'] = { cellWidth: 20 };
        output['sn'] = { cellWidth: 24.8 };
        output['sid'] = { cellWidth: 17 };
        headerKeys.map(element => {
          output[element.dataKey] = { cellWidth: 9 };
        });
      }
    } catch (error) {
      console.log(`Error in getColumnStyle()`);
    }
    return output;
  }

  const getColumns = () => {
    let output = [];
    output.push({ header: 'Survey Type', dataKey: 'surveyNm' });
    output.push({ header: 'School Name', dataKey: 'sn' });
    output.push({ header: 'School ID', dataKey: 'sid' });
    headerKeys.map(element => {
      output.push(element);
    });
    if ((authService.getRole() === 'admin')) {
      output.push({ header: 'Closed', dataKey: 'close' })
      output.push({ header: 'Blocks', dataKey: 'block' });
      output.push({ header: 'Tupes', dataKey: 'atupe' });

    }
    return output;
  }

  const pdfFileName = () => {
    let today = new Date();
    try {
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0!
      // let hoursMint = `${today.getHours()}${today.getMinutes()}`;
      let hoursMint = `${String(today.getHours()).padStart(2, '0')}${String(today.getMinutes()).padStart(2, '0')}`;

      console.log(hoursMint);

      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = `SurveyModule_${urlDistName}_${yyyy}${mm}${dd}${hoursMint}`;
    } catch (error) {
      console.log(`ERROR: ${error}, in pdfFileName().`);
    }
    return today;
  }
  const fetchDataforpdf = async () => {
    try {
      const response = await axios.post(config.basePath + 'survey/getsurveypagedata', {
        districtId: localStorage.getItem('districtId'),
        academicyear:localStorage.getItem('academicyear')
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const jsonData = response.data;
      const survPdfData = JSON.parse(JSON.stringify(jsonData));
      for (let i = 0; i < survPdfData.surveyPageData.length; i++) {
        let filteredArr = survPdfData.surveyPageData[i].schoolSurveyData.filter(f => {
          let arr = f.moduleData.map((g) => {
            if (g.value == 1) return g
          })
          arr = arr.filter(a => {
            return a
          })
          f['checkArr'] = arr
          return f['checkArr'].length > 0
        })
        survPdfData.surveyPageData[i].schoolSurveyData = filteredArr
      }
      setPdfData(survPdfData)
    } catch (error) {
      console.log("IsLoding variable: ")
    }finally {
      console.log("IsLoding variable: ")
    }
  };
  const createJSONforPDF = () => {
    let output = [];
    pdfData.surveyPageData.map(survData => {
      let jsonObj = {};
      survData.schoolSurveyData.map(survDet => {
        jsonObj = {};
        jsonObj['surveyNm'] = survData.name;
        jsonObj['sn'] = survDet.name;
        jsonObj['sid'] = survDet.ncesId;
        /* Append other data to json object */

        headerKeys.map(element => {

          jsonObj[element.dataKey] =
            survDet.moduleData.find(elem => {
              return elem['shortCode'] == element.header
            })
          jsonObj[element.dataKey] = jsonObj[element.dataKey] ? jsonObj[element.dataKey].value == 1 ? true : false : false
      
        });
        /* Append 'block' and 'aTupe' to json object if user is admin */
        if ((authService.getRole() === 'admin')) {
          jsonObj['close'] = survDet.closeData == 1 ? true : false
          jsonObj['block'] = survDet.blockData.sort().join(',');
          jsonObj['atupe'] = survDet.tupe;
        }
        output.push(jsonObj);
      });
    });
    console.log('output', output);
    return output;
  }

  const handleSendEmail = () => {
   
    console.log("values.name :", values.name);
    console.log("infovalues.info :", infovalues.info);

    if((values.name) && (infovalues.info)) {
    const formData = {
      from: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName'),
      subject: infovalues.info,
      message: values.name,
      districtId: localStorage.getItem('districtId')
    };
    console.log("Form :", formData.from);
    console.log(config.basePath + 'survey/sendEmail');
    axios.post(config.basePath + 'survey/sendEmail', formData)
      .then(response => {
        // Handle response from the server
        console.log(response.data);
        toast.success('Message sucessfully sent');
      })
      .catch(error => {
        console.error('Error:', error);
      });
      setOpenAdd(false);
      setValues({ name: "" })
    }else {
      // toast.error('Fill the required fields');
      toast.error(
        <>
          The <strong>Subject</strong> and <strong>Message</strong> fields are required. Please complete both fields before sending your message.
        </>
      );
    }
  }

  if (surveydata.length === 0) {
    return <></>;
  }

  return (
    <>
      {(isLoading === true) ? <Spinner></Spinner> : ""}
  
      <div className='survey_pageHeader'>
        <div className="surveyDateTab">
          {!isSurveySubmittedNow ? <>
            <div style={{ width: '93%' }} className="pageText">Survey Module Selection</div>
            {surveydata.distSubmitType != 'do' ? <>
              {showDownloadPdf ? <>
                <div>

                  <Button onClick={downloadSurveyPdf}>
                    <img className='pdfImage' src={require('../../assets/images/downloadpdf.png')} alt='Download Pdf'></img>
                  </Button>

                </div>
              </> : ''}
            </> : ""}
          </> : ""}
        </div>
      </div>


      <div className='survey_pageContent'>
        {!isSurveySubmittedNow ? <div className={isSave ? 'disableRadio' : 'datePlace'}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              id="surveyDatePicker"
              label="Earliest Survey Date"
              value={surveyTakenDate}
              onChange={(e) => {
                handleDateChange(e);
              }}
              disabled={localStorage.getItem("selectedYear") !== ""}
              disablePast // Disable selection of past dates
              slotProps={{  //To remove the red label color and border
                textField: {
                  error: false,
                },
              }}
              sx={{
                width: '16%',
                backgroundColor: '#003c68',
                svg: isSave ? { color: '#000' } : { color: '#fff' },
                input: { color: '#fff', border: '0px', marginTop: '8px' },
                // "& .MuiSvgIcon-root": {
                //   color: localStorage.getItem("selectedYear") !== "" ? "rgba(0, 0, 0, 0.26)" : "#fff",
                // },
                 
                  // cursor: localStorage.getItem("selectedYear") !== "" ? "not-allowed" : "auto",
                  // pointerEvents: localStorage.getItem("selectedYear") !== "" ? "none" : "auto",
             
                label: { color: '#fff', marginTop: '15px' },
                borderRadius: '5px 5px 0px 0px',
                "& label": {
                  "&.Mui-focused": {
                    color: '#fff',
                    borderColor: '#003c68'
                  }
                }
              }}
            />
          </LocalizationProvider>
        </div> : ''}
        {!isSurveySubmittedNow ?
          <div className='mainAccordionDiv'>
            {surveydata.surveyPageData.map((survey, index) => (
              <Accordion key={survey._id}>
                <AccordionSummary
                  className="accordionSummary"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ flexDirection: 'row-reverse' }}
                >
                  <Table className="accordionHeader">
                    <TableRow>
                      <TableCell className="schoolHeader">
                        <img
                          className="tickImage"
                          src={require(`../../assets/images/surveyModule/${survey.shortCode}.png`)}
                          alt="Image for FAQ"
                        />
                      </TableCell>
                      <TableCell className="schoolHeader hdrImageText">{survey.name}</TableCell>
                      <TableCell className="schoolHeader pht-text"> {(survey.shortCode != 'ss' && survey.shortCode != 'ps' && survey.shortCode != 'es') ? 'In addition to the Core, select no more than 3 additional supplemental modules. ' : (survey.shortCode == 'es') ? 'In addition to the Core, select no more than 2 additional supplemental modules.' : ''}</TableCell>
                      <TableCell className="schoolHeaderPht" name={survey.shortCode} onClick={(event) => handleResetSelection(event, survey.shortCode)}>
                        Reset Selection
                      </TableCell>
                    </TableRow>
                  </Table>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer>
                    <Table className='surveydatatable'>
                      <TableHead>
                        <TableRow>
                          <TableCell className="schoolHeader"><Tooltip title='School Name' placement="top-start"><span>School Name</span></Tooltip></TableCell>
                          <TableCell className="schoolHeader"><Tooltip title='School ID' placement="top-start"><span>School ID</span></Tooltip></TableCell>
                          {survey.schoolSurveyData[0].moduleData.map((module) => (
                            <TableCell className="schoolHeader" key={module.moduleId}>
                              <Tooltip title={module.name} placement="top-start">
                                <span>
                                  {module.shortCode === 'Mil' || module.shortCode === 'Tob' ? '\u00A0' : ''}{module.shortCode}
                                </span>
                              </Tooltip>
                            </TableCell>
                          ))}
                          {authService.getRole() != 'dc' ?
                            <>
                              <TableCell className="schoolHeader" ><Tooltip title='Custom blocks' placement="top-start"><span ref={el => {
                                if (el) {
                                  el.style.setProperty('margin-left', '9px', 'important'); //old: 9px
                                }
                              }}>Blocks</span></Tooltip></TableCell>
                              <TableCell className="schoolHeader"><Tooltip title='TUPE status' placement="top-start"><span ref={el => {
                                if (el) {
                                  el.style.setProperty('margin-left', '9px', 'important'); //old: 9px
                                }
                              }}>TUPE</span></Tooltip></TableCell>
                              <TableCell className="schoolHeader"><Tooltip title='Close survey link' placement="top-start"><span>Closed</span></Tooltip></TableCell>
                            </> : ''}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className={isSave ? 'survey_highlightColor' : 'survey_highlightColor'}>
                          <TableCell className={authService.getRole() != 'dc' ? 'survey_schoolHeader' : 'dcsurvey_schoolHeader'} colSpan={2}>
                            Check / Un-Check for entire column selection
                          </TableCell>
                          {survey.schoolSurveyData[0].moduleData.map((module, moduleIndex) => (
                            <TableCell className="survey_schoolHeader" key={module.moduleId}>
                              <FormControlLabel
                                className={isSave || (localStorage.getItem("selectedYear") !== "") ? 'disablegrid' : ''}
                                control={
                                  <MuiCheckbox
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<CheckCircleIcon />}
                                    checked={((checkboxStates[module.moduleId] || []).includes(0)) || (survey.schoolSurveyData.every((school) => school.moduleData[moduleIndex].value == 1))}
                                    onChange={(event) => handleSelectAllChange(event, module.moduleId, moduleIndex, survey.shortCode)}
                                    sx={{
                                      color: isSave || (localStorage.getItem("selectedYear") !== "") ? '#b4b0b0d6' : '#fff',
                                      transform: "scale(0.9)",
                                      '&.Mui-checked': {
                                        // color: '#18A558',
                                        color: isSave || (localStorage.getItem("selectedYear") !== "") ? '#b4b0b0d6' : '#18A558',
                                        transform: "scale(0.9)"
                                      },
                                    }}
                                  />
                                }
                              />
                            </TableCell>
                          ))}

                          <TableCell className={authService.getRole() == 'dc' ? "schoolHeader displaynone" : "schoolHeader"}>
                            <FormControl sx={{ m: 1, width: 100 }}>
                              {/* <InputLabel id="selectAllDist-label"  sx={{fontSize: 10, width: '100%', marginTop: '-10px',marginLeft:'-8px', color: '##807d7d'}}>Select Block</InputLabel> */}
                              <Select
                                placeholder='Select Blocks'
                                style={{ minWidth: '40px', height: '25px', background: '#fff', fontSize: '12px' }}
                                id="blockOptions"
                                multiple
                                value={allBlockData[survey._id] ? allBlockData[survey._id] : []}
                                renderValue={(selected) => selected.join(', ')} // Optional: to display selected options in the input
                                MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
                                onChange={(event) => handleSelectAllMultiBlock(event, survey._id)}
                                input={<OutlinedInput />}
                                disabled={localStorage.getItem("selectedYear") !== ""}
                              >
                                {survey.shortCode == 'es' && (blockOptions.map((option) => (
                                  <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                    <MuiCheckbox
                                      checked={allBlockData[survey._id] ? allBlockData[survey._id].includes(option.name) : false}
                                      sx={{
                                        color: '#003c68',
                                        transform: "scale(0.8)",
                                        padding: '4px 4px 4px 16px',
                                        '&.Mui-checked': {
                                          color: '#ff4081',
                                        },
                                      }} />
                                    <ListItemText
                                      ref={el => {
                                        if (el) {
                                          el.style.setProperty('font-size', '12px', 'important'); //old: 9px
                                        }
                                      }}
                                      primary={option.name} />
                                  </MenuItem>
                                )))}

                                {survey.shortCode == 'ms' && (msblockOptions.map((option) => (
                                  <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                    <MuiCheckbox
                                      checked={allBlockData[survey._id] ? allBlockData[survey._id].includes(option.name) : false}
                                      sx={{
                                        color: '#003c68',
                                        transform: "scale(0.8)",
                                        padding: '4px 4px 4px 16px',
                                        height: '30px',
                                        '&.Mui-checked': {
                                          color: '#ff4081',
                                        },
                                      }} />
                                    <ListItemText
                                      ref={el => {
                                        if (el) {
                                          el.style.setProperty('font-size', '12px', 'important'); //old: 9px
                                        }
                                      }}
                                      primary={option.name} />
                                  </MenuItem>
                                )))}

                                {survey.shortCode == 'hs' && (ssblockOptions.map((option) => (
                                  <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                    <MuiCheckbox
                                      checked={allBlockData[survey._id] ? allBlockData[survey._id].includes(option.name) : false}
                                      sx={{
                                        color: '#003c68',
                                        transform: "scale(0.8)",
                                        padding: '4px 4px 4px 16px',
                                        height: '30px',
                                        '&.Mui-checked': {
                                          color: '#ff4081',
                                        },
                                      }} />
                                    <ListItemText
                                      ref={el => {
                                        if (el) {
                                          el.style.setProperty('font-size', '12px', 'important'); //old: 9px
                                        }
                                      }}
                                      primary={option.name} />
                                  </MenuItem>
                                )))}


                                {survey.shortCode == 'ss' && (stblockOptions.map((option) => (
                                  <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                    <MuiCheckbox
                                      checked={allBlockData[survey._id] ? allBlockData[survey._id].includes(option.name) : false}
                                      sx={{
                                        color: '#003c68',
                                        transform: "scale(0.8)",
                                        padding: '4px 4px 4px 16px',
                                        height: '30px',
                                        '&.Mui-checked': {
                                          color: '#ff4081',
                                        },
                                      }} />
                                    <ListItemText
                                      ref={el => {
                                        if (el) {
                                          el.style.setProperty('font-size', '12px', 'important'); //old: 9px
                                        }
                                      }}
                                      primary={option.name} />
                                  </MenuItem>
                                )))}

                                {survey.shortCode == 'ps' && (psblockOptions.map((option) => (
                                  <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                    <MuiCheckbox
                                      checked={allBlockData[survey._id] ? allBlockData[survey._id].includes(option.name) : false}
                                      sx={{
                                        color: '#003c68',
                                        transform: "scale(0.8)",
                                        padding: '4px 4px 4px 16px',
                                        height: '30px',
                                        '&.Mui-checked': {
                                          color: '#ff4081',
                                        },
                                      }} />
                                    <ListItemText
                                      ref={el => {
                                        if (el) {
                                          el.style.setProperty('font-size', '12px', 'important'); //old: 9px
                                        }
                                      }}
                                      primary={option.name} />
                                  </MenuItem>
                                )))}
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell className={authService.getRole() == 'dc' ? "schoolHeader displaynone" : "schoolHeader"}>
                            <FormControl sx={{ m: 1, width: 80 }}>
                              <Select
                                style={{ minWidth: '40px', height: '25px', background: '#fff', fontSize: '12px' }}
                                id="Tupe"
                                value={selectedAllTupeOptions[survey._id] ? selectedAllTupeOptions[survey._id] : (survey.schoolSurveyData.every((school) => school.tupe) == true ? survey.schoolSurveyData[0].tupe : 2)}
                                onChange={(event) => handleSelectAllTupeOption(event, survey._id)}
                                input={<OutlinedInput />}
                                disabled={localStorage.getItem("selectedYear") !== ""}
                              >
                                <MenuItem value={2} sx={{ fontSize: '12px' }}>Yes/No</MenuItem>
                                <MenuItem value={1} sx={{ fontSize: '12px' }}>Yes</MenuItem>
                                <MenuItem value={0} sx={{ fontSize: '12px' }}>No</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell className={authService.getRole() == 'dc' ? " schoolHeader displaynone greyBg" : "schoolHeader"}>
                              <MuiCheckbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<CheckCircleIcon />}
                                checked={survey.schoolSurveyData.every((school) => school.closeData === 1)}
                                onChange={(event) => handleCloseAllChange(event, survey._id, survey.shortCode)}
                                disabled={localStorage.getItem("selectedYear") !== ""}
                                sx={{
                                color: isSave ? '#b4b0b0d6' : '#fff',
                                  transform: "scale(0.9)",
                                  '&.Mui-checked': {
                                  color: isSave ? '#b4b0b0d6' : '#18A558',
                                    transform: "scale(0.9)",
                                  },
                                }}
                              />
                        </TableCell>
                        </TableRow>
                        {survey.schoolSurveyData.map((school, indexKey) => (
                          <TableRow
                            className={isSave ? ' ' : ''}
                            key={school.schoolId}
                          >
                            <TableCell className={authService.getRole() == 'dc' ? "dcschoolBody" : "schoolBody"}>{school.name}</TableCell>
                            <TableCell className={authService.getRole() == 'dc' ? "dcschoolBody" : "schoolBody"}>{school.ncesId}</TableCell>
                            {school.moduleData.map((module, moduleIndex) => (
                              <TableCell className="schoolBody" key={module.moduleId}>
                                <FormControlLabel
                                  className={isSave ? 'disablegrid' : ''}
                                  control={
                                    <MuiCheckbox
                                      icon={<RadioButtonUncheckedIcon />}
                                      iconStyle={{ fill: '#003c68' }}
                                      checkedIcon={<CheckCircleIcon />}
                                      checked={(checkboxStates[module.moduleId] || []).includes(indexKey + 1) || module.value === 1}
                                      onChange={(event) => handleCheckboxChange(event, module.moduleId, indexKey + 1, survey._id, school.schoolId)}
                                      disabled={localStorage.getItem("selectedYear") !== ""}
                                      sx={{
                                        color: isSave ? '#b4b0b0d6' : '#003c68',
                                        transform: "scale(0.9)",
                                        '&.Mui-checked': {
                                          color: isSave ? '#b4b0b0d6' : '#18A558',
                                          transform: "scale(0.9)",
                                        },
                                      }}
                                    />
                                  }
                                />
                              </TableCell>
                            ))}
                            <TableCell className={authService.getRole() == 'dc' ? "survey_schoolHeader displaynone" : "survey_schoolHeader"}>
                              <FormControl sx={{ m: 1, width: 100 }}>
                                <Select
                                  style={{ minWidth: '40px', height: '25px', fontSize: '12px' }}
                                  id={`blockOptions-${indexKey + '_' + survey.shortCode}`}
                                  multiple
                                  value={selectedBlockOptions[indexKey + '_' + survey.shortCode] || school.blockData}
                                  onChange={(event) => handleSelectMultiBlock(event, indexKey + '_' + survey.shortCode, indexKey + 1, survey._id, school.schoolId)}
                                  renderValue={(selected) => selected.join(', ')} // Optional: to display selected options in the input
                                  input={<OutlinedInput />}
                                  MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
                                  disabled={localStorage.getItem("selectedYear") !== ""}
                                // MenuProps={MenuProps}
                                >
                                  {survey.shortCode == 'es' && (blockOptions.map((option) => (
                                    <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                      <MuiCheckbox
                                        checked={selectedBlockOptions[indexKey + '_' + survey.shortCode]?.includes(indexKey + 1) || school.blockData.includes(option.name)}
                                        sx={{
                                          color: isSave ? '#b4b0b0d6' : '#003c68',
                                          transform: "scale(0.8)",
                                          padding: '4px 4px 4px 16px',
                                          height: '30px',
                                          '&.Mui-checked': {
                                            color: isSave ? '#b4b0b0d6' : '#ff4081',
                                            transform: "scale(0.8)"
                                          },
                                        }} />
                                      <ListItemText
                                        className='survey_checkBoxText'
                                        primary={option.name} />
                                    </MenuItem>
                                  )))}

                                  {survey.shortCode == 'ms' && (msblockOptions.map((option) => (
                                    <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                      <MuiCheckbox
                                        checked={selectedBlockOptions[indexKey + '_' + survey.shortCode]?.includes(indexKey + 1) || school.blockData.includes(option.name)}
                                        sx={{
                                          color: isSave ? '#b4b0b0d6' : '#003c68',
                                          transform: "scale(0.8)",
                                          padding: '4px 4px 4px 16px',
                                          '&.Mui-checked': {
                                            color: isSave ? '#b4b0b0d6' : '#ff4081',
                                            transform: "scale(0.8)"
                                          },
                                        }} />
                                      <ListItemText className='survey_checkBoxText' primary={option.name} />
                                    </MenuItem>
                                  )))}

                                  {survey.shortCode == 'hs' && (ssblockOptions.map((option) => (
                                    <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                      <MuiCheckbox
                                        checked={selectedBlockOptions[indexKey + '_' + survey.shortCode]?.includes(indexKey + 1) || school.blockData.includes(option.name)}
                                        sx={{
                                          color: '#003c68',
                                          transform: "scale(0.8)",
                                          padding: '4px 4px 4px 16px',
                                          '&.Mui-checked': {
                                            color: '#ff4081',
                                          },
                                        }} />
                                      <ListItemText className='survey_checkBoxText' primary={option.name} />
                                    </MenuItem>
                                  )))}

                                  {survey.shortCode == 'ss' && (stblockOptions.map((option) => (
                                    <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                      <MuiCheckbox
                                        checked={selectedBlockOptions[indexKey + '_' + survey.shortCode]?.includes(indexKey + 1) || school.blockData.includes(option.name)}
                                        sx={{
                                          color: '#003c68',
                                          transform: "scale(0.8)",
                                          padding: '4px 4px 4px 16px',
                                          '&.Mui-checked': {
                                            color: '#ff4081',
                                          },
                                        }} />
                                      <ListItemText className='survey_checkBoxText' primary={option.name} />
                                    </MenuItem>
                                  )))}

                                  {survey.shortCode == 'ps' && (psblockOptions.map((option) => (
                                    <MenuItem key={option.id} value={option.name} sx={{ width: '240px', padding: '0px' }}>
                                      <MuiCheckbox
                                        checked={selectedBlockOptions[indexKey + '_' + survey.shortCode]?.includes(indexKey + 1) || school.blockData.includes(option.name)}
                                        ref={el => {
                                          if (el) {
                                            el.style.setProperty('padding', 'px 4px 4px 16px', 'important'); //old: 32px
                                          }
                                        }}
                                        sx={{
                                          color: '#003c68',
                                          transform: "scale(0.8)",
                                          padding: '4px 4px 4px 16px',
                                          height: '30px',
                                          '&.Mui-checked': {
                                            color: '#ff4081',
                                          },
                                        }} />
                                      <ListItemText className='survey_checkBoxText' primary={option.name} />
                                    </MenuItem>
                                  )))}
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell className={authService.getRole() == 'dc' ? "survey_schoolHeader displaynone" : "survey_schoolHeader"}>
                              <FormControl className={authService.getRole() == 'dc' ? " displaynone greyBg" : ""} sx={{ m: 1, width: 80 }}>
                                <Select
                                  style={{ minWidth: '40px', height: '25px', fontSize: '12px' }}
                                  id="Tupe"
                                  value={school.tupe}
                                  onChange={(event) => handleSelectTupeOption(event, survey._id, school.schoolId)}
                                  input={<OutlinedInput />}
                                  disabled={localStorage.getItem("selectedYear") !== ""}
                                >
                                  <MenuItem value={1}>Yes</MenuItem>
                                  <MenuItem value={0}>No</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell className={authService.getRole() == 'dc' ? " displaynone greyBg survey_schoolHeader" : "survey_schoolHeader"}>
                              <MuiCheckbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<CheckCircleIcon />}
                                checked={school.closeData === 1}
                                onChange={(event) => handleChange(event, school.schoolId, survey.shortCode)}
                                disabled={localStorage.getItem("selectedYear") !== ""}
                                sx={{
                                  color: isSave ? '#b4b0b0d6' : '#003c68',
                                  transform: "scale(0.9)",
                                  '&.Mui-checked': {
                                    color: isSave ? '#b4b0b0d6' : '#18A558',
                                    transform: "scale(0.9)",
                                  },
                                }}
                            />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
          </div> : ''}

        {!isSurveySubmittedNow && !isSurveySubmitted ? (
          <div className="saveButtonSpace">

            {!isSave && surveydata.distSubmitType != 'do' && localStorage.getItem("academicyear") === 'currentyear' && surveydata.surveyPageData.length > 0 ?
              <Button
                id="saveButton"
                variant="contained"
                size="small"
                className="nextBackBtn"
                onClick={handleSaveSurvey}
              >
                SAVE
              </Button> : ''
            }            

            {isSave ?
              <Button
                id="goBackButton"
                variant="contained"
                size="small"
                className="nextBackBtn"
                onClick={handleGoBack}
              >
                GO BACK
              </Button> : ''}
            {isSave ?
              <Button
                id="submitButton_id"
                size="small"
                className="nextBackBtn submitButton"
                onClick={handleSubmit}
              >
                SUBMIT
              </Button> : ''}
          </div>) : ''}
        {isSurveySubmitted && !isSurveySubmittedNow ?
          <div className="saveButtonSpace">
            {/* <Button
                id="saveButton"
                variant="contained"
                size="small"
                className="nextBackBtn"
                onClick={handleSaveSurvey}
              >
                SAVE
          </Button>  */}
            {/* <Button
                id="submitButton_id"
                size="small"
                className="nextBackBtn submitButton"
                onClick={handleSubmit}
              >
                SUBMIT
              </Button>  */}
            {localStorage.getItem("academicyear") === 'currentyear' && isShowSaveButton && (authService.getRole() === 'admin' && surveydata.distSubmitType != 'do' && surveydata.surveyPageData.length > 0) ?
              <Button
                id="save2Button"
                variant="contained"
                size="small"
                className="nextBackBtn save2Button"
                onClick={handleBTCSaveSurvey}              >
                SAVE
              </Button>
              : ''}
            <Button
              id="enrollment"
              variant="contained"
              size="small"
              className="nextEnrBtn"
              onClick={goEnrollment}
            >
              Go to Enrollment
            </Button> </div> : ''
        }

        {isSurveySubmittedNow ?
          <div className='info_mainCol'>
            {surveydata.distSubmitType != 'do' ?
              <div className='info_successIconCol'>
                <img className='info_successIcon' src={require("../../assets/images/tick.png")} alt="Download Pdf" />
              </div> : ''
            }
            <div className='info_infoCol'>
              <div>
                <p>Your survey registration is not completed until you have entered student enrollment numbers.</p>

                <p>Once you have entered enrollment numbers, your Technical Advisor will review your registration and <br />
                  email your survey links and/or request more information.</p>
              </div>
              <div className='info_mainCol'>
                {surveydata.distSubmitType != 'do' ?
                  <div>
                    <a onClick={addDashboardDialog}><img className='info_sendMailIcon' src={require("../../assets/images/mailSend.png")} alt="Download Pdf" /></a>
                  </div> : ''}
                <div>
                  <div className='info_technicalText'>Contact a Technical Advisor</div>
                  <div className='info_technicalsubText'>Send additional information</div>
                </div>
              </div>
              <div className="info_buttonCol">
                <Button variant="contained" size="small" className="info_btns info_readyBtn" onClick={goEnrollment}> I AM READY TO ENTER ENROLLMENTS </Button>
                <Button variant="contained" size="small" className="info_btns info_backBtn" onClick={handleSurveyGoBack}> BACK </Button>
              </div>
            </div>

            <Dialog
              open={openAdd}
              // onClose={addDashboardClose}
              aria-labelledby="addDashboardLabel"
              aria-describedby="addDashboardDescription"
              sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "400px",  // Set your width here
                  },
                },
              }}
            >
              <DialogContent sx={{ padding: '20px 20px' }}>
                <DialogContentText id="addDashboardDescription">
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { marginTop: '40px', width: '350px' }
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="From"
                      defaultValue={localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName')}
                      ref={el => {
                        if (el) {
                          el.style.setProperty('color', '#000', 'important'); //old: 32px
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <ContactPageOutlinedIcon />
                          </InputAdornment>
                        )
                      }}
                    />
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="To"
                      defaultValue="calschls@wested.org"
                      sx={{
                        color: "#000"
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AlternateEmailOutlinedIcon />
                          </InputAdornment>
                        )
                      }}
                    />
                    <TextField
                      label="Subject"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SubjectOutlinedIcon />
                          </InputAdornment>
                        )
                      }}
                      value={values.info}
                      onChange={wordCountHandleInfo("info")}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="Message"
                      value={values.name}
                      inputProps={{ maxLength: 300 }}
                      onChange={wordCountHandle("name")}
                      helperText={
                        <>
                          <div
                            ref={el => {
                              if (el) {
                                el.style.setProperty('text-align', 'right', 'important');
                              }
                            }}>{`${values.name.length}/300`}</div>
                        </>
                      }
                      margin="normal"
                      multiline
                      rows={4}
                      maxRows={4}
                    />
                  </Box>
                </DialogContentText>
              </DialogContent>
              {localStorage.getItem("academicyear") === 'currentyear' && (
              <DialogActions className="dash_actionFooterButton">
                <Button variant="contained" className="survey_save_button" onClick={addDashboardClose} > Cancel </Button>
                <Button variant="contained" className="survey_cancel_button" onClick={handleSendEmail} autoFocus > Send </Button>
              </DialogActions>
            )}
            </Dialog>
          </div>

          : ''}
      </div>
    </>
  )
}

export default Survey;